import React, { useState } from "react";
import { motion } from "framer-motion";
import { newArrivalIds, products } from "../../data/products";
import type { Product } from "../../types/product";
import { container, ease } from "../../utils/styles";
import { ProductGrid } from "../ProductGrid";
import { SectionHeader } from "../SectionHeader";
const tabs = ["Nieuw", "Verlichting", "Woondecoratie", "Gepersonaliseerd"] as const;
type Tab = (typeof tabs)[number];
function listFor(tab: Tab): Product[] {
  if (tab === "Nieuw") return newArrivalIds.map(id => products.find(p => p.id === id)).filter((p): p is Product => Boolean(p));
  return products.filter(p => p.category === tab).slice(0, 8);
}
export function FeaturedProducts() {
  const [tab, setTab] = useState<Tab>("Nieuw");
  const list = listFor(tab);
  return <section aria-labelledby="featured-heading" className="bg-paper pb-16 lg:pb-24" data-id="element-151" data-mp="31jzav31e4a19">
      <div className={container} data-id="element-152" data-mp="2wm61y28pd1xa">
        <SectionHeader id="featured-heading" title="Uit de studio" link={{
        label: "Bekijk alles",
        to: tab === "Nieuw" ? "/shop" : `/shop?categorie=${tab}`
      }} data-id="element-153" data-mp="2wn8t8b9xt6dq" />
        <div role="tablist" aria-label="Productselectie" className="no-scrollbar mt-6 flex gap-6 overflow-x-auto border-b border-line" data-id="element-154" data-mp="2e61iq6lw0thy">
          {tabs.map(t => <button key={t} role="tab" type="button" aria-selected={t === tab} onClick={() => setTab(t)} className={`relative shrink-0 pb-3 text-sm transition-colors duration-150 ${t === tab ? "font-medium text-ink" : "text-muted hover:text-ink"}`} data-id="element-155" data-mp="2j80o1m16u0hj">
              {t}
              {t === tab && <motion.span layoutId="featured-tab" className="absolute inset-x-0 -bottom-px h-0.5 bg-ink" transition={{
            duration: 0.25,
            ease
          }} data-id="element-156" data-mp="31wxipr0hyv0a" />}
            </button>)}
        </div>
        <div className="mt-10" data-id="element-157" data-mp="3bvwjknf0tmcq">
          <ProductGrid key={tab} products={list} data-id="element-158" data-mp="3bsihlga9rf5t" />
        </div>
      </div>
    </section>;
}